import { inject as e } from "vue";
import { themeKey as t, themeLoadedKey as m } from "./injection-symbol.js";
function h() {
  return e(t);
}
function i(o) {
  e(m)?.push(o);
}
export {
  i as onThemeLoaded,
  h as useTheme
};
//# sourceMappingURL=injection.js.map
